import { registerCollisionAnimation } from './CollisionAnimationRegistry';

registerCollisionAnimation('RIPPLE', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  ctx.beginPath();
  ctx.arc(e.pos.x, e.pos.y, e.radius * (1 + progress * 4), 0, Math.PI * 2);
  ctx.strokeStyle = determineColor(0, 1);
  ctx.lineWidth = 4 * (1 - progress);
  ctx.globalAlpha = 1 - progress;
  ctx.stroke();
});
